import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//InitStatus = true 的不能删除
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let buttonFormat = [];
    if (item.InitStatus) {
      buttonFormat.push({ actionType: 'Delete', disabled: true });
    }
    if (buttonFormat.length > 0) item.ButtonFormat = buttonFormat;
    return item;
  })
  return data;
}

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  // getJobStatusStepper({ sectionName: sectionName, parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });

  if (pageComponent.state.page.type === 'Tab') {
    sectionComponent.child.map((child, i) => {
      if (child.current != null) {
        child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
        child.current?.child.current?.setState({ moduleId: parameter });
        child.current?.customForm.current?.setState({ componentDataSource: [] });
        // console.log(child.current?.customForm.current);
        // if (child.current?.customForm.current !== null) {
        //   child.current?.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
        //   setTimeout(() => {
        //     child.current?.customForm.current?.getComponentDataSource();
        //   }, config.setTimeoutMilliSecond);
        // }

        setTimeout(() => {
          child.current?.getSectionDataByDefault();
        }, config.setTimeoutMilliSecond);
      }
    })
  } else {
    sectionComponent.customForm.current?.setState({ componentDataSource: [] });
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}


export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (pageComponent.state.page.type === 'Tab') {
    sectionComponent.child.map((child, i) => {
      if (child.current != null && child.current?.child.current?.props.sectionName === 'WorkflowStatus') {
        child.current?.setState({ showModal: true, componentType: 'Create' });
        setTimeout(() => {
          child.current?.customForm.current?.formRef.current?.setFieldsValue({ BackgroundColor: config.component.ColorPicker.defaultColor, TimeTrackingCategoryId: 0 });
        }, config.setTimeoutMilliSecond);
      }
    })
  } else {
    sectionComponent.setState({ showModal: true, componentType: 'Create' });
    pageComponent.setState({ selectedDocumentList: [] });
    setTimeout(() => {
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ BackgroundColor: config.component.ColorPicker.defaultColor, TimeTrackingCategoryId: 0 });
    }, config.setTimeoutMilliSecond);
  }
  addWorkflowStatusPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie })
}

export function addWorkflowStatusPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  const moduleId = pageComponent.state.defaultFormData.moduleId;

  Promise.all([
    httpClient.get(`/Admin/TimeTrackingCategory/GetSelectOptionList?moduleId=${moduleId}`)
  ])
    .then(([timeTrackingResponse]) => {
      if (timeTrackingResponse.data.result) {
        let componentDataSource = { ...pageComponent.state.componentDataSource };

        if (timeTrackingResponse.data.data.length > 0) {
          componentDataSource.TimeTrackingCategoryId = timeTrackingResponse.data.data;
        }

        // 一次性更新状态
        if (pageComponent.state.page.type === 'Tab') {
          sectionComponent.child.forEach(child => {
            if (child.current) {
              child.current?.customForm.current?.setState({ componentDataSource });
            }
          });
        } else {
          sectionComponent.customForm.current?.setState({ componentDataSource });
        }
      }
    })
    .catch(error => {
      globalFunction.handleError(error, pageComponent);
    });
}

export function editWorkflowStatusPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  const moduleId = pageComponent.state.defaultFormData.moduleId;

  Promise.all([
    httpClient.get(`/Admin/TimeTrackingCategory/GetSelectOptionList?moduleId=${moduleId}`)
  ])
    .then(([timeTrackingResponse]) => {
      if (timeTrackingResponse.data.result) {
        let componentDataSource = { ...pageComponent.state.componentDataSource };

        if (timeTrackingResponse.data.data.length > 0) {
          componentDataSource.TimeTrackingCategoryId = timeTrackingResponse.data.data;
        }

        // 一次性更新状态
        sectionComponent.customForm.current?.setState({ componentDataSource });
      }
    })
    .catch(error => {
      globalFunction.handleError(error, pageComponent);
    });
}

export function manageJobStatusStepper({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ currentWorkflowStatus: parameter });
  httpClient
    .get('/Admin/WorkflowStatus/GetJobTypeWithJobStatusStepper/' + parameter.WorkflowStatusId)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ showManageJobStatusStepper: true });
        setTimeout(() => {
          pageComponent.formRef.current?.setFieldsValue({ WorkflowStatusJobTypeStatusStepperList: data.data });
        }, config.setTimeoutMilliSecond);
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}